<div class="alerts" style="margin-top: 20px">
  <h3>Alert Settings</h3>
  <mat-tab-group *ngIf="individualMap && individual">
    <mat-tab *ngFor="let item of individual" [label]="item.title">
      <div style="padding-bottom: 80px" *ngIf="individualMap[item.key]">
        <!--div>
          <mat-form-field>
            <mat-label>Additional Emails</mat-label>
            <textarea matInput [(ngModel)]="individualMap[item.key].additionalEmails" ></textarea>
          </mat-form-field>
        </div-->
        <div
          style="display: flex; flex-direction: row; margin-top: 20px; margin-left: 15px; gap: 50px;"
        >
          <div style="display: flex; flex-direction: column; flex: 0 0 auto;">
            <label style="margin-left: 5px" class="radio-label"
              >Alerting Frequency</label
            >
            <mat-radio-group
              class="example-radio-group"
              [(ngModel)]="individualMap[item.key].period"
            >
              <mat-radio-button
                class="example-radio-button"
                *ngFor="let period of periods"
                [value]="period.value"
              >
                {{ period.name }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div style="display: flex; flex-direction: column; flex:0 0 auto">
            <div style="display: flex; flex-direction: row;" *ngIf="individualMap[item.key].period != 0">
              <mat-form-field style="margin-right: 5px">
                <mat-label>Start Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker1"
                  [(ngModel)]="individualMap[item.key].startDateTime"
                  name="startDate"
                  required
                />

                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker1"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              <mat-form-field>
                <mat-label>End Date</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker2"
                  [(ngModel)]="individualMap[item.key].endDateTime"
                  name="endDate"
                />

                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>
            <div
              style="display: flex; flex-direction: row; margin: 10px 0px 10px 0px"
              *ngIf="individualMap[item.key].period != 0"
            >
              <div style="position: relative">
                <mat-form-field style="position: relative">
                  <mat-label>Alert Email Delivery Time</mat-label>

                  <input
                    matInput
                    [(ngModel)]="individualMap[item.key].startTime"
                    (focus)="individualMap[item.key].timeShown = true"
                    (blur)="checkTime(individualMap[item.key])"
                    name="startTime"
                    required
                    autocomplete="off"
                  />
                </mat-form-field>
                <div
                  *ngIf="individualMap[item.key].timeShown"
                  class="time-picker"
                >
                  <div
                    style="display: flex; flex-direction: row; justify-content: center; align-items: center; align-self: center"
                  >
                    <div
                      style="display: flex; flex-direction: column; justify-content: center; align-items: stretch; align-self: center;"
                    >
                      <div
                        (click)="
                          individualMap[item.key].localHours =
                            (individualMap[item.key].localHours + 1) % 24;
                          updateTime(individualMap[item.key])
                        "
                      >
                        <div class="up"></div>
                      </div>
                      <div>
                        {{
                          individualMap[item.key].localHours | number : '2.0-0'
                        }}
                      </div>
                      <div
                        (click)="
                          individualMap[item.key].localHours =
                            (individualMap[item.key].localHours + 23) % 24;
                          updateTime(individualMap[item.key])
                        "
                      >
                        <div class="down"></div>
                      </div>
                    </div>
                    <div style="flex:0 0 10px; justify-content: center">:</div>
                    <div
                      style="display: flex; flex-direction: column; justify-content: center; align-items: stretch; align-self: center"
                    >
                      <div
                        (click)="
                          individualMap[item.key].localMinutes =
                            (individualMap[item.key].localMinutes + 1) % 60;
                          updateTime(individualMap[item.key])
                        "
                      >
                        <div class="up"></div>
                      </div>
                      <div>
                        {{
                          individualMap[item.key].localMinutes
                            | number : '2.0-0'
                        }}
                      </div>
                      <div
                        (click)="
                          individualMap[item.key].localMinutes =
                            (individualMap[item.key].localMinutes + 59) % 60;
                          updateTime(individualMap[item.key])
                        "
                      >
                        <div class="down"></div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button (click)="setNow(individualMap[item.key])">
                      Now
                    </button>
                  </div>
                </div>
                <div
                  class="tooltip-trigger"
                  pTooltip="Note:  alerts to complete or review control items across multiple projects will be grouped into a single email."
                ></div>
              </div>
            </div>

            <mat-form-field *ngIf="individualMap[item.key].period == 2">
              <mat-label>Day</mat-label>
              <mat-select
                [(ngModel)]="individualMap[item.key].daysOfWeek"
                name="daysOfWeek"
                multiple
                required
              >
                <mat-option
                  *ngFor="let dayOfWeek of daysOfWeek"
                  [value]="dayOfWeek.value"
                >
                  {{ dayOfWeek.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div
              *ngIf="
                individualMap[item.key].period == 3 ||
                individualMap[item.key].period == 4
              "
            >
              <mat-form-field style="margin-right: 5px">
                <mat-label>Day</mat-label>
                <mat-select
                  [(ngModel)]="individualMap[item.key].daysOfMonth"
                  name="dayInMonth"
                  multiple
                  required
                >
                  <mat-option
                    *ngFor="let dayInMonth of daysInMonth"
                    [value]="dayInMonth.value"
                  >
                    {{ dayInMonth.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="individualMap[item.key].period == 4">
                <mat-label>Month</mat-label>
                <mat-select
                  [(ngModel)]="individualMap[item.key].months"
                  name="months"
                  required
                  multiple
                >
                  <mat-option
                    *ngFor="let month of months"
                    [value]="month.value"
                  >
                    {{ month.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div style="flex:0 0 auto">
            <div>Projects:</div>
            <div
              *ngFor="
                let projectStatus of individualMap[item.key].projectStatuses
              "
            >
              <mat-checkbox [(ngModel)]="projectStatus.checked">{{
                projectStatus.name
              }}</mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="General">
      <div>
        <mat-checkbox [(ngModel)]="individualMap['survey'].enabled"
          >Survey</mat-checkbox
        >
      </div>
      <div>
        <mat-checkbox [(ngModel)]="individualMap['awareness'].enabled"
          >Awareness</mat-checkbox
        >
      </div>
    </mat-tab>
  </mat-tab-group>
  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
    <button
      mat-raised-button
      [disabled]="loading"
      (click)="onSave()"
      style="border-radius: 6px"
    >
      Save
    </button>
    <img
      *ngIf="loading"
      src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
    />
    <!--button mat-raised-button (click)="onClose()">Cancel</button-->
  </div>
</div>
